import { render } from "./EmptyTextHandler.vue?vue&type=template&id=6d3058f4&ts=true"
import script from "./EmptyTextHandler.vue?vue&type=script&lang=ts"
export * from "./EmptyTextHandler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__